"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntryHandlerKeyword_1 = require("./EntryHandlerKeyword");
/**
 * Handles @graph entries.
 */


var EntryHandlerKeywordGraph =
/*#__PURE__*/
function (_EntryHandlerKeyword_) {
  _inherits(EntryHandlerKeywordGraph, _EntryHandlerKeyword_);

  function EntryHandlerKeywordGraph() {
    _classCallCheck(this, EntryHandlerKeywordGraph);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntryHandlerKeywordGraph).call(this, '@graph'));
  }

  _createClass(EntryHandlerKeywordGraph, [{
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(parsingContext, util, key, keys, value, depth) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // The current identifier identifies a graph for the deeper level.
                parsingContext.graphStack[depth + 1] = true;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function handle(_x, _x2, _x3, _x4, _x5, _x6) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }]);

  return EntryHandlerKeywordGraph;
}(EntryHandlerKeyword_1.EntryHandlerKeyword);

exports.EntryHandlerKeywordGraph = EntryHandlerKeywordGraph;